import { createAsyncThunk } from "@reduxjs/toolkit"

import * as services from "../api/services"
import {
  DEFLECT_SECTION,
  DEFLECT_ANALYTICS_SLICE_NAME as SLICE_NAME
} from "./deflectAnalytics.constants"

// One thunk per endpoint. Each takes `{ key, params }`: the endpoint is the thunk, the store key
// is the caller's, which is how a card and its full page read the same endpoint into different
// keys (see DEFLECT_SECTION).
//
// Silent by design (no handleApiError): every section renders its own empty state rather than
// raising a global error toast per section.

export const getDeflectKpis = createAsyncThunk(
  `${SLICE_NAME}/get_kpis`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectKpis(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectTrend = createAsyncThunk(
  `${SLICE_NAME}/get_trend`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectTrend(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectQueue = createAsyncThunk(
  `${SLICE_NAME}/get_queue`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectQueue(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectFlow = createAsyncThunk(
  `${SLICE_NAME}/get_flow`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectFlow(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectByChannel = createAsyncThunk(
  `${SLICE_NAME}/get_by_channel`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectByChannel(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectByCountry = createAsyncThunk(
  `${SLICE_NAME}/get_by_country`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectByCountry(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectByProgram = createAsyncThunk(
  `${SLICE_NAME}/get_by_program`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectByProgram(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectMatchRateMatrix = createAsyncThunk(
  `${SLICE_NAME}/get_match_rate_matrix`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectMatchRateMatrix(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectRepeatCardholders = createAsyncThunk(
  `${SLICE_NAME}/get_repeat_cardholders`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectRepeatCardholders(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectChannelTrends = createAsyncThunk(
  `${SLICE_NAME}/get_channel_trends`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectChannelTrends(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

export const getDeflectLookups = createAsyncThunk(
  `${SLICE_NAME}/get_lookups`,
  async ({ params }, { rejectWithValue }) => {
    const response = await services.getDeflectLookups(params)
    if (!response.ok) return rejectWithValue(response.data ?? null)
    return response.data
  }
)

// Store key -> the endpoint behind it.
export const SECTION_THUNKS = {
  [DEFLECT_SECTION.KPIS]: getDeflectKpis,
  [DEFLECT_SECTION.TREND]: getDeflectTrend,
  [DEFLECT_SECTION.QUEUE]: getDeflectQueue,
  [DEFLECT_SECTION.FLOW]: getDeflectFlow,
  [DEFLECT_SECTION.BY_CHANNEL]: getDeflectByChannel,
  [DEFLECT_SECTION.BY_COUNTRY]: getDeflectByCountry,
  [DEFLECT_SECTION.BY_PROGRAM]: getDeflectByProgram,
  [DEFLECT_SECTION.MATCH_RATE_MATRIX]: getDeflectMatchRateMatrix,
  [DEFLECT_SECTION.REPEAT_CARDHOLDERS]: getDeflectRepeatCardholders,
  [DEFLECT_SECTION.REPEAT_CARDHOLDERS_PAGE]: getDeflectRepeatCardholders,
  [DEFLECT_SECTION.CHANNEL_TRENDS]: getDeflectChannelTrends,
  [DEFLECT_SECTION.LOOKUPS]: getDeflectLookups
}
